import { render, staticRenderFns } from "./registerSoUser.vue?vue&type=template&id=4142b21b"
import script from "./registerSoUser.vue?vue&type=script&lang=js"
export * from "./registerSoUser.vue?vue&type=script&lang=js"
import style0 from "./registerSoUser.vue?vue&type=style&index=0&id=4142b21b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports